import { Navigate, Route, Routes } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import { LoadingScreen } from '@/components/LoadingScreen/LoadingScreen';
import { BrokerageContainer } from '@/containers/BrokerageContainer';
import { BrokeragesContainer } from '@/containers/BrokeragesContainer';
import { FilesContainer } from '@/containers/FilesContainer';
import { HelloContainer } from '@/containers/HelloContainer';
import { LenderContainer } from '@/containers/LenderContainer';
import { LendersContainer } from '@/containers/LendersContainer';
import { OrganizationContainer } from '@/containers/OrganizationContainer';
import { OrganizationsContainer } from '@/containers/OrganizationsContainer';
import { PeopleContainer } from '@/containers/PeopleContainer';
import { SignInContainer } from '@/containers/SignInContainer';
import { TenantContainer } from '@/containers/TenantContainer';
import { TenantsContainer } from '@/containers/TenantsContainer';
import { TemplatesContainer } from '@/containers/TemplatesContainer';

/**
 * One route per harness. Add a `<Route>` here and a container under
 * `src/containers/` — that pair is the whole recipe for a new harness page.
 */
export function AppRoutes() {
  const { status } = useAuth();

  if (status === 'restoring') {
    return <LoadingScreen message="Restoring session…" />;
  }

  if (status === 'anonymous') {
    return <SignInContainer />;
  }

  return (
    <Routes>
      <Route path="/" element={<HelloContainer />} />
      <Route path="/files" element={<FilesContainer />} />
      <Route path="/templates" element={<TemplatesContainer />} />
      <Route path="/lenders" element={<LendersContainer />} />
      <Route path="/lenders/:key" element={<LenderContainer />} />
      <Route path="/brokerages" element={<BrokeragesContainer />} />
      <Route path="/brokerages/:id" element={<BrokerageContainer />} />
      <Route path="/tenants" element={<TenantsContainer />} />
      <Route path="/tenants/:id" element={<TenantContainer />} />
      <Route path="/organizations" element={<OrganizationsContainer />} />
      <Route path="/organizations/:id" element={<OrganizationContainer />} />
      <Route path="/people" element={<PeopleContainer />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
